import { useState } from 'react'
import type { FormEvent } from 'react'
import { Link } from 'react-router'

interface Props {
  onSubmit: (token: string) => void
  retry: boolean
}

// The whole auth model: one shared ADMIN_TOKEN, typed in and kept for the tab.
export default function AdminTokenGate({ onSubmit, retry }: Props) {
  const [token, setToken] = useState('')

  function submit(event: FormEvent) {
    event.preventDefault()
    const trimmed = token.trim()
    if (trimmed) onSubmit(trimmed)
  }

  return (
    <main className="flex min-h-screen flex-col items-center justify-center bg-ink px-4 text-ink-hi">
      <form onSubmit={submit} className="w-full max-w-sm panel p-6">
        <h1 className="text-lg font-semibold">Admin</h1>
        <p className="mt-1 text-sm text-ink-mid">
          {retry
            ? 'That token was rejected. Check ADMIN_TOKEN on the server and try again.'
            : 'Enter the ADMIN_TOKEN this server was started with.'}
        </p>
        <input
          value={token}
          onChange={(event) => setToken(event.target.value)}
          type="password"
          autoFocus
          placeholder="Admin token"
          className="mt-4 w-full rounded border border-line-strong bg-ink px-3 py-2 text-sm"
        />
        <button
          type="submit"
          disabled={!token.trim()}
          className="mt-3 w-full rounded bg-signal px-4 py-2 text-sm font-semibold text-ink hover:bg-signal-dim disabled:opacity-50"
        >
          Unlock
        </button>
        <p className="mt-4 text-xs text-ink-lo">
          Kept for this browser tab only.{' '}
          <Link to="/" className="underline underline-offset-2 hover:text-ink-mid">
            Back to the app
          </Link>
        </p>
      </form>
    </main>
  )
}
